import { createRoot } from "react-dom/client";
import { lazy, Suspense } from "react";
import { Controller } from "@hotwired/stimulus";

const FactorsWrapper = lazy(
  () => import("../components/authentication/FactorsWrapper"),
);

// Connects to data-controller="two-factor-authentications"
export default class extends Controller {
  static values = { context: String };

  connect() {
    this.root = createRoot(this.element);
    this.root.render(
      <Suspense fallback={null}>
        <FactorsWrapper context={this.contextValue} />
      </Suspense>,
    );
  }

  disconnect() {
    if (this.root) {
      this.root.unmount();
    }
  }
}
